import React from 'react'
import { connect } from 'react-redux'
import { Typography } from '@material-ui/core'
import { themeObj } from 'components/withRoot'
import { Done, SettingsInputAntenna, Loop, Pause } from '@material-ui/icons'
import FAB from './FAB'
import language from 'utils/vast-languagepack'

export default connect(
  (state) => ({ status: state.campaign.addOrEdit.campaign.status }),
  null,
)(({ status, classes }) => {
  const textMap = {
    W: language.campaign.campaignStatus.campaignPlay,
    P: language.campaign.campaignStatus.campaignPause,
    L: language.campaign.campaignStatus.campaignLive,
    C: language.campaign.campaignStatus.campaignComplete,
  }

  const colorMap = {
    W: themeObj.palette.pink,
    P: themeObj.palette.orange,
    L: themeObj.palette.green,
    C: themeObj.palette.secondary.main,
  }

  const IconMap = {
    W: Loop,
    P: Pause,
    L: SettingsInputAntenna,
    C: Done,
  }

  const Icon = status ? IconMap[status] : null
  const iconComponent = Icon ? (
    <Icon
      style={{
        color: colorMap[status],
        marginRight: 5,
        verticalAlign: 'middle',
        fontSize: 12,
      }}
    />
  ) : null

  return (
    <div>
      {iconComponent}
      <Typography
        className={classes.statusText}
        style={{
          color: colorMap[status] || colorMap.W,
          fontWeight: 500,
          display: 'inline-block',
          // fontSize: 12,
        }}
        variant="subtitle1"
      >
        {textMap[status] || textMap.W}
      </Typography>
      <FAB style={{ marginLeft: 10 }} size="small" />
    </div>
  )
})
